import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

// Single source of truth for whether the payment overdue banner renders.
// The banner and every layout that offsets for it must share this condition,
// otherwise non-admins reserve space for a banner that never shows.
export function getIsPaymentOverdueBannerVisible(isFeatureEnabled) {
  return isFeatureEnabled('paymentOverdueBanner') && isFeatureEnabled('userManagement');
}

// Hook for function components. Class components (which can't use hooks) should
// call getIsPaymentOverdueBannerVisible directly with their own isFeatureEnabled.
export default function useIsPaymentOverdueBannerVisible() {
  const isFeatureEnabled = useIsFeatureEnabled();
  return getIsPaymentOverdueBannerVisible(isFeatureEnabled);
}
